class Tag {
  constructor(title, description, isSpecial, parentId) {
    this.title = title;
    this.description = description;
    this.isSpecial = isSpecial;
    this.parentId = parentId;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      allTags: [],
      allTagsForOther: [],
      tag: new Tag('', '', false, null),
      tagPaginationList: [],
      allParentTags: [],
    };
  },
  methods: {
    getListOfTagsForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllTags').then(() => {
        if (this.$store.state.tagModule.successFlag) {
          // this.allTagsForOther = this.$store.state.tagModule.allTags;

          this.allTagsForOther = Array.isArray(this.$store.state.tagModule.allTags)
            ? this.$store.state.tagModule.allTags
            : [];

          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.tagModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfTagsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.tagModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfTagsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllTags: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllTags').then(() => {
        if (this.$store.state.tagModule.successFlag) {
          // this.allTags = this.$store.state.tagModule.allTags;
          this.allTags = Array.isArray(this.$store.state.tagModule.allTags)
            ? this.$store.state.tagModule.allTags
            : [];
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.tagModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllTags();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.tagModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllTags();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfTagsWithPagination: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      let isParent = null;
      let isActive = null;
      if (this.searchIsActive == 1) {
        isActive = true;
      } else if (this.searchIsActive == 2) {
        isActive = false;
      }
      if (this.searchIsParent == 1) {
        isParent = true;
      } else if (this.searchIsParent == 2) {
        isParent = false;
      }
      this.$store
        .dispatch('getTagsWithPagination', {
          pageNumber: this.page,
          pageSize: this.pageSize,
          title: this.searchText,
          isParent: isParent,
          isActive: isActive,
        })
        .then(() => {
          if (this.$store.state.tagModule.successFlag) {
            this.tagPaginationList = [];
            let temp = this.$store.state.tagModule.tags;
            for (let i = 0; i < temp.length; i++) {
              let isSpecial = true;
              if (temp[i].isSpecial === false) {
                isSpecial = false;
              }
              let isActive = true;
              if (temp[i].isActive === false) {
                isActive = false;
              }
              this.tagPaginationList.push({
                counter: i + 1,
                title: temp[i].title ? temp[i].title : '-',
                description: temp[i].description ? temp[i].description : '-',
                parent: temp[i].parent ? temp[i].parent.title : '-',
                id: temp[i].id,
                isSpecial: isSpecial,
                isActive: isActive,
              });
            }
            if (this.load.val) {
              this.load.val = false;
            }
            this.totalPages = Number(this.$store.state.tagModule.totalPages);
            if (this.$refs.pagination) {
              this.$refs.pagination.totalPages = Number(this.$store.state.tagModule.totalPages);
              this.$refs.pagination.totalRecords = Number(this.$store.state.tagModule.totalRecords);
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.tagModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getListOfTagsWithPagination();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.tagModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getListOfTagsWithPagination();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    setTotalPagesFun: function (totalPages) {
      if (this.$refs.pagination) {
        this.$refs.pagination.totalPages = Number(totalPages);
      } else {
        this.setTotalPagesFun(totalPages);
      }
    },
    addTagFunction: function () {
      if (!this.tag.title) {
        this.snackText = 'عنوان برچسب نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.tag.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان برچسب نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addTag', this.tag).then(() => {
        if (this.$store.state.tagModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.showAddEditModal = false;
          this.disabelConfirm = false;
          this.snackText = ' برچسب با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.tag = new Tag('', '', false, null);
          this.getListOfTagsWithPagination();
          if (!this.tag.parentId) this.getAllParentTagsFunction();
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.tagModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addTagFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.tagModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addTagFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getTagFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getTag', id).then(() => {
        if (this.$store.state.tagModule.successFlag) {
          let temp = this.$store.state.tagModule.tag;
          this.tag.id = temp.id;
          this.tag.title = temp.title;
          this.tag.description = temp.description;
          this.tag.isSpecial = temp.isSpecial;
          this.tag.parentId = temp.parent ? temp.parent.id : null;
          this.active = temp.isActive;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.tagModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getTagFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.tagModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getTagFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    editTagFunction: function () {
      if (!this.tag.title) {
        this.snackText = 'عنوان برچسب نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.tag.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان برچسب نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      this.tag.isActive = this.active;
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('editTag', this.tag).then(() => {
        if (this.$store.state.tagModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          this.showAddEditModal = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getListOfTagsWithPagination();

          if (!this.tag.parentId) this.getAllParentTagsFunction();
          this.snackText = ' برچسب با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.tag = new Tag('', '', false, null);
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.tagModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.editTagFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.tagModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.editTagFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deleteTagFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deleteTag', this.tagId).then(() => {
        if (this.$store.state.tagModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getListOfTagsWithPagination();
          this.getAllParentTagsFunction();
          this.snackText = ' برچسب با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.tagModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteTagFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.tagModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteTagFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllParentTagsFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllParentTags').then(() => {
        if (this.$store.state.tagModule.successFlag) {
          this.allParentTags = this.$store.state.tagModule.allParentTags;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.tagModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllParentTagsFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.tagModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllParentTagsFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.tagModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
